import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["title", "disabled", "data-testid", "onClick"]
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioSpinner = _resolveComponent("StudioSpinner")!

  return (_openBlock(), _createElementBlock("div", {
    "data-testid": "studio-button-group",
    class: _normalizeClass({
      'tw-inline-flex tw-divide-x tw-overflow-hidden': true,
      'tw-h-8 tw-rounded-lg tw-text-xs': _ctx.size === 'base',
      'tw-h-6 tw-rounded-md tw-text-2xs': _ctx.size === 'small',
      'tw-divide-slate-400 tw-bg-black tw-text-white dark:tw-divide-slate-600 dark:tw-bg-white dark:tw-text-black':
        _ctx.variant === 'filled',
      'tw-divide-slate-200 tw-border tw-border-slate-200 tw-text-black dark:tw-divide-slate-800 dark:tw-border-slate-800 dark:tw-text-white':
        _ctx.variant === 'outline'
    })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (button, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (!button.hidden)
          ? (_openBlock(), _createElementBlock("button", {
              key: button.trackingId,
              title: button.title,
              disabled: button.disabled || button.isLoading,
              "data-testid": button.trackingId,
              class: _normalizeClass([
          {
            'tw-flex tw-items-center tw-justify-center tw-font-medium focus:tw-outline-none focus:tw-ring-deep-orange-600': true,
            'tw-px-3 tw-py-2': _ctx.size === 'base',
            'tw-px-2': _ctx.size === 'small',
            'hover:tw-bg-deep-orange-600 dark:tw-ring-offset-black dark:hover:tw-text-white':
              _ctx.variant === 'filled' && !button.disabled,
            'hover:tw-bg-deep-orange-50 hover:tw-text-deep-orange-600': _ctx.variant === 'outline' && !button.disabled,
            '!tw-cursor-not-allowed tw-bg-slate-200 tw-text-slate-400 dark:tw-bg-slate-400 dark:tw-text-slate-200':
              button.disabled,
            'tw-bg-deep-orange-50 tw-text-deep-orange-600 focus:tw-ring-deep-orange-600 dark:tw-ring-offset-black dark:hover:tw-text-white':
              _ctx.showActiveButton && _ctx.activeButtonIndex === index
          },
          button.extraClasses
        ]),
              onClick: e => _ctx.handleButtonClick(button, e)
            }, [
              (button.isLoading)
                ? (_openBlock(), _createBlock(_component_StudioSpinner, {
                    key: 0,
                    "data-testid": "studio-spinner",
                    coverContainer: false,
                    size: "xxsmall"
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (button.iconComponent)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass({
              'tw-flex tw-items-center tw-justify-center': true,
              '-tw-mx-[5px]': _ctx.size === 'small',
              '-tw-mx-[7px]': _ctx.size === 'base',
              '-tw-ml-1 tw-mr-1': button.label,
              'tw-h-4 tw-w-4': _ctx.size === 'small',
              'tw-h-5 tw-w-5': _ctx.size === 'base'
            })
                        }, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(button.iconComponent)))
                        ], 2))
                      : _createCommentVNode("", true),
                    (button.label)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(button.label), 1))
                      : _createCommentVNode("", true)
                  ], 64))
            ], 10, _hoisted_1))
          : _createCommentVNode("", true)
      ], 64))
    }), 256))
  ], 2))
}